import React from "react";
import numeral from "numeral";
import ClerkIncrementsButtonsGrid from "./ClerkIncrementsButtonsGrid";
import {TaggedLogger} from "@nextlot/core/utilities";
import {AuctionsManager, DataStore} from "@nextlot/core/webcast";


const _logger = TaggedLogger.get('ClerkRoundStartSetOpeningBidCmp');


type CmpPropsType = {
    currentRoundId: string,
}


type CmpStateType = Partial<{
    currentRoundId: string,
    openingBidCentsValue: number,
    openingBidInputValue: number,
    canStartRound: boolean,
    inputFocusRequest?: boolean,
}>

export default class ClerkRoundStartSetOpeningBidCmp extends React.Component<CmpPropsType, CmpStateType> {
    private readonly refInputOpeningBid: any;


    constructor(props) {
        super(props);
        // _logger.debug('.constructor: ', props);

        this.refInputOpeningBid = React.createRef();

        this.state = {
            currentRoundId: null,
            openingBidCentsValue: 0,
            openingBidInputValue: 0,
            canStartRound: false,
        }
    }



    static getDerivedStateFromProps(props, state):CmpStateType {
        // reset openingBid to zero any time there's a new currentRoundId
        if (props.currentRoundId !== state.currentRoundId) {
          return {
              currentRoundId: props.currentRoundId,
              openingBidCentsValue: 0,
              openingBidInputValue: 0,
              canStartRound: false,
              inputFocusRequest: true,
          };
        }
        return null;
    }


    componentDidMount(): void {
        this.refInputOpeningBid.current.focus();
    }


    componentDidUpdate():void {
        if (this.state.inputFocusRequest) {
            this.setState({
                inputFocusRequest: false,
            }, () => {
                this.refInputOpeningBid.current.focus();
            });
        }
    }



    handleIncrementButtonClick = (valueCents):void => {
        let newValueCents = this.state.openingBidCentsValue + valueCents;
        newValueCents = newValueCents < 0 ? 0 : newValueCents; // no negative values

        this.setState({
            openingBidCentsValue: newValueCents,
            openingBidInputValue: numeral(newValueCents / 100).format('0[.]0'),
            canStartRound: (newValueCents > 0),
            inputFocusRequest: true,
        })
    };



    handleOpeningBidValueInputChange = (event):void => {
        const newValueCents = numeral(event.target.value).value() * 100;

        this.setState({
            openingBidCentsValue: newValueCents,
            openingBidInputValue: numeral(newValueCents / 100).format('0[.]0'),
            canStartRound: (newValueCents > 0),
        });
    };



    handleFormSubmit = (evt):void => {
        evt.preventDefault();
        evt.stopPropagation();

        AuctionsManager.currentWebcastAuctionHandler.controller.sendAskingBidUpdate(this.props.currentRoundId, this.state.openingBidCentsValue);
    };


    handleResetButtonClick = ():void => {
        this.setState({
            openingBidCentsValue: 0,
            openingBidInputValue: 0,
            canStartRound: false,
            inputFocusRequest: true,
        });
    };





    render() {
        // _logger.debug('.render(): state:', this.state);

        return (
            <div className="d-flex flex-column">

                <form className="px-3 py-3 row align-items-center" onSubmit={this.handleFormSubmit}>

                    <div className="col-auto">
                        <label>Opening bid</label>
                    </div>

                    <div className="col-auto">
                        <input
                            type="number" step="0.01"
                            ref={this.refInputOpeningBid}
                            value={this.state.openingBidInputValue}
                            onChange={this.handleOpeningBidValueInputChange}
                            className={`form-control mx-3 ${this.state.canStartRound ? 'is-valid' : 'is-invalid'}`}
                        />
                    </div>

                    <div className="col-auto">
                        <button
                            type="submit"
                            className={`ms-3 px-4 btn ${this.state.canStartRound ? 'btn-success' : 'btn-outline-success disabled'}`}
                            disabled={ ! this.state.canStartRound}>
                            Start round
                        </button>
                    </div>

                    <div className="col-auto">
                        <button
                            type="button"
                            className="ms-3 btn btn-sm btn-outline-secondary"
                            onClick={this.handleResetButtonClick}>
                            Reset
                        </button>
                    </div>

                </form>


                <ClerkIncrementsButtonsGrid
                    onButtonClick={this.handleIncrementButtonClick}
                    valuesList={DataStore.config.default_clerk_increments}
                    valuesSign={1}
                />

                <br />

                <ClerkIncrementsButtonsGrid
                    onButtonClick={this.handleIncrementButtonClick}
                    valuesList={DataStore.config.default_clerk_increments}
                    valuesSign={-1}
                />
            </div>
        )
    }
}


